(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bartolini-cuore-testata"] && !Shopify.designMode) return;
  try {
    const CHIAVE = 'bartolini:salvate';

  function quante() {
    try {
      const grezzo = window.localStorage.getItem(CHIAVE);
      return grezzo ? JSON.parse(grezzo).length : 0;
    } catch (e) {
      return 0;
    }
  }

  class CuoreTestata extends HTMLElement {
    connectedCallback() {
      this.conto = this.querySelector('.b-cuore-testata__conto');
      this.mostra();
      this.ascolta = () => this.mostra();
      document.addEventListener('bartolini:salvate', this.ascolta);
      window.addEventListener('storage', this.ascolta);
    }

    disconnectedCallback() {
      document.removeEventListener('bartolini:salvate', this.ascolta);
      window.removeEventListener('storage', this.ascolta);
    }

    mostra() {
      const n = quante();
      // Si vede sempre: e' il modo di arrivare ai preferiti, e se comparisse solo quando
      // ce n'e' gia' uno nessuno saprebbe che il posto esiste.
      if (n > 0) {
        this.setAttribute('data-piene', '');
        this.conto.textContent = n > 99 ? '99+' : String(n);
        this.conto.hidden = false;
      } else {
        this.removeAttribute('data-piene');
        this.conto.hidden = true;
      }
    }
  }

  if (!customElements.get('cuore-testata')) {
    customElements.define('cuore-testata', CuoreTestata);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bartolini-salva"] && !Shopify.designMode) return;
  try {
    const CHIAVE = 'bartolini:salvate';
  const URL_PREFERITI = 'https://bartolini.venditausato.workers.dev/api/preferito';

  /* Solo un contatore aggregato per montatura, nessun dato del visitatore:
     non serve consenso cookie. Se fallisce (rete assente, worker giu), il
     cuore continua a funzionare uguale: e' un di piu', non un requisito. */
  function segnala(handle, azione) {
    try {
      fetch(URL_PREFERITI, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ handle, azione }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) {
      /* silenzio: il cuore non deve mai dipendere da questa chiamata */
    }
  }

  function leggi() {
    try {
      const grezzo = window.localStorage.getItem(CHIAVE);
      return grezzo ? JSON.parse(grezzo) : [];
    } catch (e) {
      // Finestra anonima, spazio pieno, cookie di terze parti spenti: si continua a vuoto.
      return [];
    }
  }

  function scrivi(elenco) {
    try {
      window.localStorage.setItem(CHIAVE, JSON.stringify(elenco));
    } catch (e) {
      /* se non si puo' scrivere, il cuore resta acceso per questa pagina e basta */
    }
    document.dispatchEvent(new CustomEvent('bartolini:salvate', { detail: elenco }));
  }

  class SalvaMontatura extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle;
      this.tasto = this.querySelector('.b-salva__tasto');
      if (!this.tasto || !this.handle) return;
      this.mostra();
      this.tasto.addEventListener('click', () => this.cambia());
      this.ascolta = () => this.mostra();
      document.addEventListener('bartolini:salvate', this.ascolta);
    }

    disconnectedCallback() {
      if (this.ascolta) document.removeEventListener('bartolini:salvate', this.ascolta);
    }

    mostra() {
      const dentro = leggi().includes(this.handle);
      this.tasto.setAttribute('aria-pressed', dentro ? 'true' : 'false');
      const parola = this.querySelector('.b-salva__parola');
      if (parola && parola.textContent.trim() !== '') {
        parola.textContent = dentro ? 'Salvata' : 'Salva';
      }
    }

    cambia() {
      const elenco = leggi();
      const i = elenco.indexOf(this.handle);
      if (i === -1) {
        elenco.push(this.handle);
        segnala(this.handle, 'aggiungi');
      } else {
        elenco.splice(i, 1);
        segnala(this.handle, 'togli');
      }
      scrivi(elenco);
    }
  }

  if (!customElements.get('salva-montatura')) {
    customElements.define('salva-montatura', SalvaMontatura);
  }
  } catch(e) { console.error(e); }
})();

})();
